import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0701f47f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","gap":"10px","flex-wrap":"wrap"} }
const _hoisted_2 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 15px"}
}

import { ref, reactive, computed, PropType, onMounted, nextTick } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { FormType, ObjectFormItem, DateType } from '@/components/cmForm/types'
import { useParseTime } from '@/hooks'
import {
  AuthenticTerminalListItem,
  SoftwareUsageReq,
  TerminalViewService
} from './terminal-view.service'
import { unixSecondsOrUndefined } from '@/utils/time'
import dayjs from 'dayjs'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import InstalledDetail from './_components/installed-detail/installed-detail.vue'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'
import InstallStatisticsExport from '@/views/dashboard/manage/genuine-software-usage/_components/install-statistics-export/install-statistics-export.vue'
import GroupTreeSelector from '@/views/dashboard/_components/group-tree-selector/group-tree-selector.vue'
import { TableActOpt, TableOpt } from '@/components/cmTable/types'
import { FormSize } from '@/components/cmForm/types'
import { listCol } from '@/utils/list-columns-i18n'
import { TerminalTypeOptions, TerminalTypeLabel } from '@/views/dashboard/_enum/terminal-type'
import { defaultAuthenticSoftUsageMonthRangeStrings } from '../../_utils/default-month-range'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-view',
  props: {
  hasPermission: { type: Boolean, default: false },
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  /** 嵌入抽屉：如正版授权页统计卡 — 不传时间区间 + has_authorized_soft */
  embedDefaults: {
    type: Object as PropType<{
      emptyTime?: boolean
      hasAuthorizedSoft?: number
    } | null>,
    default: null
  }
},
  emits: ['viewAll'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
const props = __props

const emits = __emit

const injector = useReflectiveInjector([TerminalViewService])
const service = injector.get(TerminalViewService)

const tableRef = ref<any>()
const { refreshList } = useCmTableListRefresh(tableRef)
const activeRow = ref({} as AuthenticTerminalListItem)
const detailVisible = ref(false)
const totalCount = computed(() => tableRef.value?.total ?? 0)

// 与下方 onMounted 原逻辑一致：默认最近一个月。必须在 setup 就写好，否则 CmTable 子组件 onMounted 会先调 getList，出现「第一次无 start/end、父组件 onMounted 再补」的双请求。
const defaultMonthRange = defaultAuthenticSoftUsageMonthRangeStrings()
const isFullEmptyTimeEmbed = props.viewMode === TableViewMode.full && Boolean(props.embedDefaults?.emptyTime)
const dateRangeInit = isFullEmptyTimeEmbed ? ([] as string[]) : defaultMonthRange
const [rangeStart, rangeEnd] = isFullEmptyTimeEmbed ? [undefined, undefined] : useParseTime(defaultMonthRange)
const initialDateForForm =
  !isFullEmptyTimeEmbed && rangeStart != null && rangeEnd != null
    ? ([new Date(rangeStart * 1000), new Date(rangeEnd * 1000)] as any[])
    : []

const form = reactive<{
  searchKey: string
  date_range?: string[]
  date?: any[]
  start_time?: number
  end_time?: number
  /** 与软件使用统计终端视图、RankCard 一致；请求参数仍映射为 group_id */
  groupId: number
  /** 系统类型筛选，与列表接口 `system_type` 一致 */
  system_type?: number
}>({
  searchKey: '',
  date_range: dateRangeInit,
  date: initialDateForForm,
  start_time: rangeStart,
  end_time: rangeEnd,
  groupId: -1,
  system_type: undefined
})

const formColumns = computed<ObjectFormItem<typeof form, 'date_range' | 'system_type'>>(() => {
  void locale.value
  return {
    group_id: {
      prop: 'group_id',
      label: t('group.groupName'),
      type: FormType.Select,
      colOpt: { style: 'flex: 0 0 150px' },
      hiddenAllLabel: true,
      slot: true,
      outSearchFiledFlag: true,
    },
    date_range: {
      prop: 'date_range',
      label: t('genuineSoftwareUsage.timeRange'),
      type: FormType.Date,
      dateType: DateType.DateRange,
      colOpt: { style: 'flex:0 0 260px' },
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      dateOpt: {
        'value-format': 'YYYY-MM-DD',
        'start-placeholder': t('common.startDate'),
        'end-placeholder': t('common.endDate'),
        clearable: Boolean(isFullEmptyTimeEmbed)
      },
      events: {
        change: (val: string[]) => {
            const [start, end] = useParseTime(val)
            form.start_time = start
            form.end_time = end
            handleQuery()
        }
      }
    },
    system_type: {
      colOpt: { style: 'flex: 0 0 130px' },
      label: t('portManage.systemType'),
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      type: FormType.Select,
      selectOpt: { clearable: true },
      dictData: TerminalTypeOptions,
      events: {
        change: () => {
          void refreshList()
          service.updateEvent.next(form)
        },
      },
    },
  }
})

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const defaultRangeFull = defaultAuthenticSoftUsageMonthRangeStrings()
const [defaultStartParsed, defaultEndParsed] = useParseTime(defaultRangeFull)
const defaultStartTime = props.viewMode === TableViewMode.full ? defaultStartParsed : undefined
const defaultEndTime = props.viewMode === TableViewMode.full ? defaultEndParsed : undefined

function resolvedStartEnd(overrides?: { start_time?: number; end_time?: number }) {
  const o = overrides ?? {}
  let fromStart: number | undefined
  let fromEnd: number | undefined
  if (form.date?.[0] && form.date?.[1]) {
    const range = [dayjs(form.date[0]).format('YYYY-MM-DD'), dayjs(form.date[1]).format('YYYY-MM-DD')]
    const [s, e] = useParseTime(range)
    fromStart = s
    fromEnd = e
  }
  return {
    start: unixSecondsOrUndefined(o.start_time) ?? unixSecondsOrUndefined(form.start_time) ?? unixSecondsOrUndefined(fromStart) ?? defaultStartTime,
    end: unixSecondsOrUndefined(o.end_time) ?? unixSecondsOrUndefined(form.end_time) ?? unixSecondsOrUndefined(fromEnd) ?? defaultEndTime
  }
}

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: listCol(t, 'operation'), width: 100, align: 'left', fixed: 'right' },
    actionButtons: () => [
      {
        type: 'terminalSoftDetail',
        name: listCol(t, 'detail'),
        opt: { size: FormSize.Small, text: true, type: 'text' },
        disabled: () => !props.hasPermission,
      },
    ],
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
    columns: [
      { prop: 'computer_name', type:'COMPUTER', label: listCol(t, 'computerName'), columnOpt: { minWidth: 200 } },
      { prop: 'group_name', label: listCol(t, 'groupName'), columnOpt: { minWidth: 120 } },
      { prop: 'user_mark', label: listCol(t, 'userMark'), columnOpt: { minWidth: 120 } },
      { prop: 'ip_address', type:'IP', label: listCol(t, 'ipAddress'), columnOpt: { minWidth: 200 } },
      {
        prop: 'system_type',
        label: t('portManage.systemType'),
        columnOpt: { minWidth: 120 },
        formatter: (_row: AuthenticTerminalListItem, value: number) => {
          const label = TerminalTypeLabel[value as keyof typeof TerminalTypeLabel]
          return label ?? '--'
        },
      },
      { prop: 'authorized_soft_count', label: t('genuineSoftwareUsageColumns.authSoftAuthorizedCount'), columnOpt: { minWidth: 140, sortable: 'custom' } },
      { prop: 'unauthorized_soft_count', label: t('genuineSoftwareUsageColumns.authSoftUnauthorizedCount'), columnOpt: { minWidth: 160, sortable: 'custom' } },
    ],
    rowKey: 'device_id',
    showActionBar: false,
    showSearch: false,
    showRightToolbar: true,
    path: 'list',
    totalPath: 'total',
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    height: props.viewMode === TableViewMode.preview ? undefined : '100%'
  }
})

function getListApi(params: any) {
  if (!props.hasPermission) return Promise.resolve({ list: [], total: 0 })
  const p = params ?? {}
  const emptyTime = props.viewMode === TableViewMode.full && Boolean(props.embedDefaults?.emptyTime)
  const { start, end } = emptyTime
    ? { start: undefined as number | undefined, end: undefined as number | undefined }
    : resolvedStartEnd({ start_time: p.start_time, end_time: p.end_time })
  const req: SoftwareUsageReq = {
    key_word: (p.searchKey ?? p.key_word ?? form.searchKey ?? '') as string,
    start_time: start != null ? String(start) : undefined,
    end_time: end != null ? String(end) : undefined,
    group_id: (p.groupId ?? p.group_id ?? form.groupId ?? -1) as number,
    system_type: form.system_type,
    page: p.page || 1,
    limit: props.viewMode === TableViewMode.preview ? 10 : 20,
    sort: p.sort || 'auth_soft_count',
    asc: p.asc ?? false,
    authenticsoft_flag: 1,
    ...(props.embedDefaults?.hasAuthorizedSoft === 1 ? { has_authorized_soft: 1 } : {})
  }
  return service.getSoftwareUsage(req)
}

async function handleSearch(value: string) {
  form.searchKey = value
  await refreshList()
}

async function handleQuery() {
  await refreshList()
}

async function handleReset() {
  form.searchKey = ''
  // full：嵌入「空时间」保持不传时间；否则重置为最近一个月；preview 清空日期
  if (props.viewMode === TableViewMode.full) {
    if (props.embedDefaults?.emptyTime) {
      form.date_range = []
      form.date = []
      form.start_time = undefined
      form.end_time = undefined
    } else {
      const range = defaultAuthenticSoftUsageMonthRangeStrings()
      const [s, e] = useParseTime(range)
      if (s != null && e != null) {
        form.date_range = range
        form.date = [new Date(s * 1000), new Date(e * 1000)] as any[]
        form.start_time = s
        form.end_time = e
      }
    }
  } else {
    form.date_range = []
    form.date = []
    form.start_time = undefined
    form.end_time = undefined
  }
  form.groupId = -1
  form.system_type = undefined
  await refreshList()
  service.updateEvent.next(form)
}

function handleGroupChange(groupId: number) {
  if (form.groupId !== groupId) {
    form.groupId = groupId
    handleQuery()
    service.updateEvent.next(form)
  }
}

function handleViewAll() {
  if (!props.hasPermission) return
  emits('viewAll')
}

function handleUsageExport(type: 0 | 1) {
  if (!props.hasPermission) return
  const emptyTime = props.viewMode === TableViewMode.full && Boolean(props.embedDefaults?.emptyTime)
  const { start, end } = emptyTime
    ? { start: undefined as number | undefined, end: undefined as number | undefined }
    : resolvedStartEnd()
  const req: SoftwareUsageReq = {
    key_word: form.searchKey || '',
    start_time: start != null ? String(start) : undefined,
    end_time: end != null ? String(end) : undefined,
    group_id: form.groupId ?? -1,
    system_type: form.system_type,
    sort: 'authorized_soft_count',
    asc: false,
    authenticsoft_flag: 1,
    page: 0,
    limit: 0,
    ...(props.embedDefaults?.hasAuthorizedSoft === 1 ? { has_authorized_soft: 1 } : {})
  }
  service.download(type, req, t('genuineSoftwareUsage.exportFilenameUsageTerminalView'))
}


function showDetail(row: AuthenticTerminalListItem) {
  if (!props.hasPermission) return
  activeRow.value = row
  detailVisible.value = true
}

function handleTableAction(payload: { type?: string; rowItem?: AuthenticTerminalListItem }) {
  if (!props.hasPermission) return
  if (payload.type === 'terminalSoftDetail' && payload.rowItem) {
    showDetail(payload.rowItem)
  }
}

function refreshData() {
  void refreshList()
  service.updateEvent.next(form)
}

onMounted(async () => {
  await nextTick()
})

__expose({
  refreshData,
  pagination: computed(() => ({ total: totalCount.value })),
  searchParams: form
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "table-opt": tableOpt.value,
      "table-act-opt": tableActOpt.value,
      api: getListApi,
      "has-permission": __props.hasPermission,
      modelValue: form,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form) = $event)),
      "page-option": pageOption,
      onHandleAction: handleTableAction
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: form,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
          "form-columns": formColumns.value,
          disabled: !__props.hasPermission,
          "show-search": true,
          "search-placeholder": _ctx.$t('genuineSoftwareUsage.searchPlaceholderTerminal'),
          "popover-threshold": 0,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          group_id: _withCtx(() => [
            _createVNode(GroupTreeSelector, {
              "default-group-id": form.groupId ?? -1,
              disabled: !__props.hasPermission,
              onSelected: handleGroupChange
            }, null, 8, ["default-group-id", "disabled"])
          ]),
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(ExportDropdown, {
                "button-text-i18n-key": "genuineSoftwareUsage.exportUsage",
                "has-permission": __props.hasPermission,
                disabled: !totalCount.value,
                onExport: handleUsageExport
              }, null, 8, ["has-permission", "disabled"]),
              _createVNode(InstallStatisticsExport, { "has-permission": __props.hasPermission }, null, 8, ["has-permission"])
            ]),
            (props.viewMode === _unref(TableViewMode).preview)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "",
                  size: "small",
                  class: "cm-ui-ml10",
                  plain: "",
                  onClick: handleViewAll,
                  disabled: !__props.hasPermission
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.viewAll')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
      ]),
      _: 1
    }, 8, ["table-opt", "table-act-opt", "has-permission", "modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailVisible).value = $event)),
      "destroy-on-close": "",
      size: "65%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('genuineSoftwareUsage.terminalUsedSoft', { name: activeRow.value.computer_name })), 1),
        _createVNode(InstalledDetail, {
          "computer-name": activeRow.value.computer_name,
          "device-id": activeRow.value.device_id,
          date: form.date,
          "has-permission": __props.hasPermission
        }, null, 8, ["computer-name", "device-id", "date", "has-permission"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})